import { AfterViewInit, Component, ElementRef, forwardRef, Inject, NgZone, OnInit, PLATFORM_ID } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TransferState } from '@angular/platform-browser';
import { ConvertHelper } from '@barthauer/abc/core';
import {
  DxCheckBoxComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';

@Component({
  selector: 'abc-check-box',
  standalone: true,
  template: '',
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => _AbcCheckBoxComponent),
    },
  ],
})
export class _AbcCheckBoxComponent extends DxCheckBoxComponent implements OnInit, AfterViewInit {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    const tooltTip = new AbcTooltipDirective(this.element);
    tooltTip.elementClassName = '.dx-checkbox-text';
  }

  override set value(value: boolean) {
    if (typeof value === 'string') {
      super.value = ConvertHelper.toBoolean(value);
    } else {
      super.value = value;
    }
  }
}
